import { BarChart3, CircleDollarSign, Megaphone, SearchCheck, SquareArrowOutUpRight, UsersRound } from "lucide-react";

const seoBenefitCards = [
  {
    title: "Tăng Thứ Hạng Tìm Kiếm Từ Khóa",
    description:
      "Website được tối ưu chuẩn SEO đáp ứng tốt hơn tiêu chí xếp hạng của công cụ tìm kiếm, giúp các từ khóa dễ dàng lên top và xuất hiện ngay khi người dùng tìm kiếm.",
    icon: SearchCheck,
  },
  {
    title: "Tạo Ra Doanh Thu Bền Vững",
    description:
      "Thiết kế website chuẩn SEO chính là giải pháp hiệu quả đem lại cơ hội tăng trưởng vượt bậc và bền vững cho doanh nghiệp khi thu hút được khách hàng tiềm năng.",
    icon: BarChart3,
  },
  {
    title: "Mở Rộng Khách Hàng Tiềm Năng",
    description:
      "Khi website có khả năng hiển thị tốt trên công cụ tìm kiếm, doanh nghiệp sẽ tiếp cận được thêm nhiều nhóm khách hàng mới mà không bị giới hạn bởi khu vực địa lý.",
    icon: SquareArrowOutUpRight,
  },
  {
    title: "Tăng Nhận Diện Thương Hiệu",
    description:
      "Để mọi người biết đến thương hiệu của mình nhiều hơn, website chính là cầu nối giúp doanh nghiệp phủ sóng trên Internet, tăng nhận diện thương hiệu.",
    icon: Megaphone,
  },
  {
    title: "Nâng Cao Trải Nghiệm Người Dùng",
    description:
      "Trang web tối ưu SEO có giao diện đẹp mắt, nhiều tính năng tiện ích, tốc độ load trang nhanh chóng mang đến trải nghiệm người dùng tốt hơn.",
    icon: UsersRound,
  },
  {
    title: "Tiết Kiệm Chi Phí Marketing",
    description:
      "Website chuẩn SEO nhanh lên top, giúp doanh nghiệp tiếp cận khách hàng dễ dàng hơn mà không cần tốn quá nhiều chi phí cho việc quảng bá sản phẩm / dịch vụ.",
    icon: CircleDollarSign,
  },
];

const SectionWebsiteSeoBenefits: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fffaf9_0%,#ffffff_100%)] py-16 sm:py-18 lg:py-20">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[-120px] bottom-10 h-72 w-72 rounded-full bg-red-100/70 blur-3xl" />
        <div className="absolute right-[-100px] top-8 h-80 w-80 rounded-full bg-rose-100/70 blur-3xl" />
        <div className="absolute inset-0 opacity-[0.06]">
          <div
            className="h-full w-full"
            style={{
              backgroundImage:
                "radial-gradient(circle at 15% 20%, rgba(220,38,38,0.18) 0, rgba(220,38,38,0.18) 2px, transparent 3px), linear-gradient(30deg, rgba(220,38,38,0.14) 1px, transparent 1px), linear-gradient(150deg, rgba(220,38,38,0.12) 1px, transparent 1px)",
              backgroundSize: "170px 170px, 170px 170px, 170px 170px",
              backgroundPosition: "0 0, 0 0, 85px 85px",
            }}
          />
        </div>
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="mx-auto max-w-[920px] text-center">
          <span className="inline-flex rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
            Lợi ích SEO
          </span>
          <h2 className="mt-5 text-[26px] font-semibold leading-[1.18] text-[#d92d20] sm:text-[32px] lg:text-[42px]">
            Lợi Ích Của Thiết Kế Website Chuẩn SEO
          </h2>
          <p className="mx-auto mt-4 max-w-[860px] text-[14px] leading-7 text-slate-600 sm:text-[15px]">
            Có rất nhiều lợi ích mà một thiết kế web chuẩn SEO có thể mang lại cho doanh nghiệp của bạn,
            nhất là trong thời đại kỹ thuật số như hiện nay. Cụ thể như:
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-[1120px] gap-5 lg:grid-cols-2">
          {seoBenefitCards.map(({ title, description, icon: Icon }) => (
            <article
              key={title}
              className="rounded-[24px] border border-red-100 bg-[linear-gradient(180deg,#ffffff_0%,#fff8f8_100%)] p-6 text-left shadow-[0_18px_38px_rgba(127,29,29,0.07)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_22px_44px_rgba(127,29,29,0.1)]"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="max-w-[calc(100%-72px)]">
                  <h3 className="text-[21px] font-semibold leading-7 text-[#2f1a1a]">{title}</h3>
                  <p className="mt-4 text-[14px] leading-8 text-slate-600">{description}</p>
                </div>

                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ff5a47_0%,#dc2626_100%)] text-white shadow-[0_10px_24px_rgba(220,38,38,0.22)]">
                  <Icon size={22} />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionWebsiteSeoBenefits;
